<template>
	<!-- 全局参数 -->
	<div class="systemGlobal">
		<div class="systemGlobalPC pulbic_system_oparetionBlock" >
			<div class="systemGlobalPC-conditions public_operatBtn" style="margin-left: 0px;">
				<el-button class="public_saleWater_xinzeng"  type="primary" icon="iconfont icon-tianjia" @click="addGlobalclick" v-shiroHiden="solelist" id="新增">新增</el-button>
			</div>
			<div class="systemGlobalPC-table" >
				<div class="systemGlobalPC-table-li public-table-bg">
					<div class="systemGlobalPC-table-li-code">参数代码</div>
					<div class="systemGlobalPC-table-li-par">参数值</div>
					<div class="systemGlobalPC-table-l-said">说明</div>
					<div class="systemGlobalPC-table-li-btn">操作</div>
				</div>
				<div class="systemGlobalPC-table-li public-hover public-table-bg" v-for="(item,index) in globalList" :key="index">
					<div class="systemGlobalPC-table-li-code">{{item.ORMTB403CA00}}</div>
					<div class="systemGlobalPC-table-li-par">{{item.ORMTB403CA02}}</div>
					<div class="systemGlobalPC-table-l-said">{{item.ORMTB403CA01}}</div>
					<div class="systemGlobalPC-table-li-btn">
						<el-button class="public_icon_xiugai public_icon_width public_icon_margin" type="primary"  size="small" @click="upClick(item)" v-shiroHiden="solelist" id="修改">修改</el-button>
						<el-button class="public_icon_jinyong public_icon_width public_icon_margin" type="danger"  size="small" @click="delClick(item)" v-shiroHiden="solelist" id="删除">删除</el-button>
					</div>
				</div>
			</div>
			<div class="systemGlobalPC-no-data" v-if="globalList.length==0">
				暂无数据
			</div>
			<div class="systemGlobalPC-page-size">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage2" :page-sizes="[10, 20, 30, 40]" :page-size="pagelimit" layout="total,sizes, prev, pager, next" :total="globalTotal">
				</el-pagination>
			</div>
			<div class="public-dialog">
				<el-dialog title="新增全局参数" :visible.sync="systemGlobalPCCode" width="30%" :closeOnClickModal="false">
					<div class="systemGlobalPC-add-code">
						<div class="systemGlobalPC-add-code-table">
							<div class="systemGlobalPC-add-code-table-li">
								<div class="systemGlobalPC-add-code-table-li-code">参数代码</div>
								<div class="systemGlobalPC-add-code-table-li-ipt">
									<input type="text"  v-model="addDlobalObj.ORMTB403CA00" maxlength="4" @keyup="addCodeChange" @blur="addCodeBlur" >
								</div>
								<div class="systemGlobalPC-add-code-table-li-nece">*必填*</div>
							</div>
							<div class="systemGlobalPC-add-code-table-li">
								<div class="systemGlobalPC-add-code-table-li-code">参数值</div>
								<div class="systemGlobalPC-add-code-table-li-ipt">
									<input type="text" maxlength="20"  v-model="addDlobalObj.ORMTB403CA01">
								</div>
								<div class="systemGlobalPC-add-code-table-li-nece">*必填*</div>
							</div>
							<div class="systemGlobalPC-add-code-table-li">
								<div class="systemGlobalPC-add-code-table-li-code">说明</div>
								<div class="systemGlobalPC-add-code-table-li-ipt">
									<input type="text" maxlength="100"  v-model="addDlobalObj.ORMTB403CA02">
								</div>
								<div class="systemGlobalPC-add-code-table-li-nece">*必填*</div>
							</div>
						</div>
						<div class="systemGlobalPC-add-code-btn">
							<el-button type="primary" @click="addGlobalSave">保存</el-button>
							<el-button type="warning" @click="systemGlobalPCCode=false">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
			<div class="public-dialog">
				<el-dialog title="编辑全局参数" :visible.sync="systemGlobalPCUpCode" width="30%" :closeOnClickModal="false">
					<div class="systemGlobalPC-add-code">
						<div class="systemGlobalPC-add-code-table">
							<div class="systemGlobalPC-add-code-table-li">
								<div class="systemGlobalPC-add-code-table-li-code">参数代码</div>
								<div class="systemGlobalPC-add-code-table-li-ipt">
									<!-- <input type="text" v-model="upDlobalObj.ORMTB403CA00" maxlength="4" @blur="upCodeBlur"> -->
									{{upDlobalObj.ORMTB403CA00}}
								</div>
								<div class="systemGlobalPC-add-code-table-li-nece"></div>
							</div>
							<div class="systemGlobalPC-add-code-table-li">
								<div class="systemGlobalPC-add-code-table-li-code">参数值</div>
								<div class="systemGlobalPC-add-code-table-li-ipt">
									<input type="text" v-model="upDlobalObj.ORMTB403CA02" maxlength="20">
								</div>
								<div class="systemGlobalPC-add-code-table-li-nece">*必填*</div>
							</div>
							<div class="systemGlobalPC-add-code-table-li">
								<div class="systemGlobalPC-add-code-table-li-code">说明</div>
								<div class="systemGlobalPC-add-code-table-li-ipt">
									<input type="text" v-model="upDlobalObj.ORMTB403CA01" maxlength="100">
								</div>
								<div class="systemGlobalPC-add-code-table-li-nece">*必填*</div>
							</div>
						</div>
						<div class="systemGlobalPC-add-code-btn">
							<el-button type="primary" @click="saveClick">保存</el-button>
							<el-button type="warning" @click="systemGlobalPCUpCode=false">取消</el-button>
						</div>
					</div>
				</el-dialog>
			</div>
		</div>
	</div>
</template>

<script >
	export default{
		data(){
			return {
				currentPage2:1,
				systemGlobalPCCode:false,
				systemGlobalPCUpCode:false,
				addDlobalObj:{
					ORMTB403CA00:'',
					ORMTB403CA01:'',
					ORMTB403CA02:''
				},
				upDlobalObj:{
					ORMTB403CA00:'',
					ORMTB403CA01:'',
					ORMTB403CA02:''
				},
				loading:false,
				globalList:[],
				globalTotal:0,
				pagesize:1,
				pagelimit:10,
				iscode:1,
				upiscode:1,
				uobj:'',
				solelist:'',
				// 历史缓存
				currentUrl:this.$route.path,
				historyInfo:''
			}
		},
		created(){
			this.solelist=this.$baseAPI.querSoleList(this.$store.state.solelist,this.$route.path)
			// 赋值，缓存销毁
			this.historyInfo=JSON.parse(sessionStorage.getItem(this.currentUrl))
			sessionStorage.removeItem(this.currentUrl)
			if(this.historyInfo!=null&&this.historyInfo!=''){
				this.init()
			}
		},
		mounted() {
			this.uobj=this.$store.state.uobj
			this.postGlobalList()
		},
		// 存储数据
		beforeDestroy() {
			var obj={
				currentPage2:this.currentPage2,//当前页数
				pagesize:this.pagesize,//页码
				pagelimit:this.pagelimit//每页条数
			}
			sessionStorage.setItem(this.currentUrl,JSON.stringify(obj))
		},
		methods:{
			//初始化数据
			init(){
				this.currentPage2=this.historyInfo.currentPage2
				this.pagesize=this.historyInfo.pagesize
				this.pagelimit=this.historyInfo.pagelimit
			},
			addCodeChange(){
				this.addDlobalObj.ORMTB403CA00 = this.addDlobalObj.ORMTB403CA00.replace(/[^\d]/g, '')
			},
			delClick(item) {// 删除
				var that=this
				this.$confirm(`请确认是否删除:${item.ORMTB403CA00}, 是否继续?`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					var url="/orm/ormtb403/deleteById"
					var data={
						ORMTB403ID:item.ORMTB403ID,
						// SETTB204CD01:item.SETTB204CD01
					}
					this.axios.post(url,data).then((res)=>{
						// console.log(res)
						if(res.data.code==200){
							this.$message.success( '删除成功' );
							this.postGlobalList()
						}else{
							this.$message.success( res.data.message);
						}
					}).catch(()=>{
					})
				}).catch(() => {
					
				});
			},
			handleSizeChange(val) {//当前每页多少条
				this.pagelimit=val
				this.pagesize=1
				this.postGlobalList()
			},
			handleCurrentChange(val) {//当前多少页
				this.pagesize=val
				this.postGlobalList()
			},
			
			postGlobalList(){//获取参数列表
				this.loading=true
				var url="/orm/ormtb403/selectPageList"
				var data={
					ORMTB400ID:this.uobj.ormtb400.ORMTB400ID,//企业id
					page:this.pagesize,
					limit:this.pagelimit
				}
				var loading=this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.post(url,data).then((res)=>{
					console.log(res)
					setTimeout(()=>{
						loading.close()
					},300)
					this.loading=false
					if(res.data.code==200){
						this.globalList=res.data.data||[]
						this.globalTotal=res.data.count
					}else{
						this.globalList=[]
						this.globalTotal=0
						this.$message.error(res.data.message)
					}
				}).catch(errrse=>{
					loading.close()
				})
			},
			addGlobalclick(){//新增全局参数弹框
				this.systemGlobalPCCode=true
				this.addDlobalObj={
					ORMTB403CA00:'',
					ORMTB403CA01:'',
					ORMTB403CA02:''
				}
			},
			addCodeBlur(){//校验代码值是否唯一
				if(this.addDlobalObj.ORMTB403CA00.trim().length==4){
					var url="/orm/ormtb403/checkOrmtb403ca00"
					var data={
						ORMTB403CA00:this.addDlobalObj.ORMTB403CA00,
						ORMTB400ID:this.uobj.ormtb400.ORMTB400ID
					}
					this.axios.post(url,data).then((res)=>{
						// console.log(res)
						if(res.data.code==200){
							this.iscode=0
						}else if(res.data.code!=200){
							this.iscode=1
							this.$message.error(res.data.message)
						}
					}).catch(()=>{
						
					})
				}
			},
			upCodeBlur(){//修改校验参数代码
				if(this.upDlobalObj.ORMTB403CA00.trim().length==4&&this.intcode!=this.upDlobalObj.ORMTB403CA00){
					var url="/orm/ormtb403/checkOrmtb403ca00"
					var data={
						ORMTB403CA00:this.upDlobalObj.ORMTB403CA00,
						ORMTB400ID:this.uobj.ormtb400.ORMTB400ID
					}
					this.axios.post(url,data).then((res)=>{
						// console.log(res)
						
						if(res.data.code==200){
							this.upiscode=0
						}else if(res.data.code!=200){
							this.upiscode=1
							this.$message.error(res.data.message)
						}
					})
				}
				if(this.intcode==this.upDlobalObj.ORMTB403CA00) return this.upiscode=0
			},
			addGlobalSave(){//新增保存
				if(this.addDlobalObj.ORMTB403CA00.trim().length!=4) return this.$message.error('参数代码请输入4位数字')
				if(this.addDlobalObj.ORMTB403CA01.trim().length>0&&this.addDlobalObj.ORMTB403CA02.trim().length>0){
					if(this.iscode==1) return this.$message.error('参数代码已存在')
					let loading = this.$loading({
						lock: true,
						text: '请求中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.5)'
					});
					var url="/orm/ormtb403/insertOrmtb403"
					var data={
						ORMTB403CA00:this.addDlobalObj.ORMTB403CA00,
						ORMTB403CA02:this.addDlobalObj.ORMTB403CA01,
						ORMTB403CA01:this.addDlobalObj.ORMTB403CA02,
						ORMTB400ID:this.uobj.ormtb400.ORMTB400ID,
					}
					this.axios.post(url,data).then((res)=>{
						// console.log(res)
						setTimeout(()=>{
							loading.close()
						},300)
						if(res.data.code==200){
							this.postGlobalList()
							this.systemGlobalPCCode=false
							this.$message.success('新增成功');
						}else{
							this.$message.error(res.data.message)
						}
					}).catch(()=>{
						loading.close();
					})
				}else{
					  this.$message.error('请完善全局参数信息');
				}
			},
			upClick(item){//修改
				this.systemGlobalPCUpCode=true
				var str=JSON.stringify(item)
				this.upDlobalObj=JSON.parse(str)
				this.intcode=item.ORMTB403CA00
				this.upiscode=0
			},
			saveClick(){//修改保存
				if(this.upDlobalObj.ORMTB403CA01.trim().length>0&&this.upDlobalObj.ORMTB403CA02.trim().length>0){
					// if(this.upiscode==1) return this.$message.error('参数代码已存在')
					let loading = this.$loading({
						lock: true,
						text: '请求中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.5)'
					});
					var url='/orm/ormtb403/updateOrmtb403ById'
					var data={
						ORMTB403ID:this.upDlobalObj.ORMTB403ID,
						ORMTB403CA02:this.upDlobalObj.ORMTB403CA02,
						ORMTB403CA01:this.upDlobalObj.ORMTB403CA01,
					}
					this.axios.post(url,data).then((res)=>{
						setTimeout(()=>{
							loading.close()
						},300)
						// console.log(res)
						if(res.data.code==200){
							this.postGlobalList()
							this.$message.success( '修改成功' );
							this.systemGlobalPCUpCode=false
							
						}else{
							this.$message.error(res.data.message)
						}
					}).catch(()=>{
						loading.close()
					})
				}else{
					  this.$message.error('请完善全局参数信息');
				}
			}
		}
	}
</script>

<style scoped>
	.systemGlobalPC{
		padding:30px 40px 20px 20px;
		color: #333;
		font-size: 18px;
	}
	.systemGlobalPC-no-data{
		height: 80px;
		line-height: 80px;
		text-align: center;
		border-bottom:1px solid #CDCDCD;
	}
	.systemGlobalPC-table{
		margin-top: 20px;
	}
	.systemGlobalPC-table-li{
		display: flex;
		border-bottom:1px solid #CDCDCD;
	}
	.systemGlobalPC-table-li {
		display: flex;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		color: #333;
		border-bottom: 1px solid #CDCDCD;
	}
	
	.systemGlobalPC-table-li:first-child{
		font-weight: bold;
		font-size: 16px;
		height: 48px;
		line-height: 48px;
	}
	.systemGlobalPC-table-li>div{
		text-align: center;
		/* height: 50px;
		line-height: 50px; */
	}
	.systemGlobalPC-table-li-code,
	.systemGlobalPC-table-li-par{
		flex: .4;
	}
	.systemGlobalPC-table-l-said{
		flex: 1.2;
	}
	.systemGlobalPC-table-li-btn{
		flex: .4;
	}
	.systemGlobalPC-page-size{
		text-align: right;
		margin-top: 20px;
	}
	.systemGlobalPC-add-code-table-li{
		display: flex;
		font-size: 16px;
		color:#333;
	}
	.systemGlobalPC-add-code-table-li>div{
		height: 40px;
		line-height: 40px;
		border:1px solid #CDCDCD;
		border-top: none;
		text-align: center;
	}
	.systemGlobalPC-add-code-table-li:first-child>div{
		border-top: 1px solid #CDCDCD;
	}
	.systemGlobalPC-add-code-table-li>div:last-child{
		border: none;
	}
	.systemGlobalPC-add-code-table-li .systemGlobalPC-add-code-table-li-code{
		flex:1;
		border-right: none;
	}
	.systemGlobalPC-add-code-table-li-code{
		background: rgba(240,252,255,1);
	}
	.systemGlobalPC-add-code-table-li-ipt{
		flex:1;
	}
	.systemGlobalPC-add-code-table-li-ipt>input{
		height: 100%;
		width: 100%;
		text-align: center;
		border: none;
		box-sizing: border-box;
		font-size: 14px;
		padding: 0 10px;
		vertical-align: top;
	}
	.systemGlobalPC-add-code-table-li-ipt>input:focus{
		outline: none;
	}
	.systemGlobalPC-add-code-table-li-nece{
		flex:.3;
		color: #FF4D35;
	}
	.systemGlobalPC-add-code-btn{
		margin-top: 20px;
		text-align: center;
	}
</style>
